export default __webpack_public_path__ + "static/CookieRun-Regular.subset-34b92b32e592ac67e0c02b20f28b486a.woff";